import useUser from "./useUser";
import { useEffect } from "react";
import { navigate, useLocation } from "@reach/router";
import { checkKeys } from "../helpers/functions";
import _ from "lodash";

const EXCLUDE_URL = ["welcome", "create-profile"];

export default function useIfLoggedIn() {
  const { userObject, setUserObject } = useUser();
  const location = useLocation();
  const token = localStorage.getItem("auth_token");

  useEffect(() => {
    if (
      !_.isEmpty(userObject) &&
      userObject.emailVerified &&
      !checkKeys(userObject) &&
      !EXCLUDE_URL.some((path) => location?.pathname?.includes(path))
    ) {
      if (token) {
        navigate("/dashboard");
      } else {
        setUserObject({});
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [userObject]);
}
